var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2698_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.0975 24.3488C90.5794 15.0712 80.9306 5.4225 71.6531 2.90438C65.9662 1.485 58.3444 0.024375 48 0C37.6575 0.02625 30.0356 1.485 24.3488 2.90438C15.0712 5.42438 5.4225 15.0712 2.90438 24.3488C1.485 30.0356 0.02625 37.6575 0 48C0.02625 58.3444 1.485 65.9662 2.90438 71.6531C5.4225 80.9306 15.0712 90.5775 24.3488 93.0975C30.0356 94.5169 37.6613 95.9756 48 96.0019C58.3444 95.9756 65.9662 94.5169 71.6531 93.0975C80.9306 90.5775 90.5794 80.9306 93.0975 71.6531C94.5169 65.9662 95.9756 58.3406 96.0019 48C95.9756 37.6575 94.5169 30.0356 93.0975 24.3488Z",
    fill: "#E5F4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.262 78.8662C41.3833 80.2706 54.6169 80.2706 67.7382 78.8662C73.1007 78.2437 78.2382 73.1006 78.8663 67.7381C80.2707 54.6168 80.2707 41.3831 78.8663 28.2619C78.2439 22.8994 73.1007 17.7619 67.7382 17.1337C54.6169 15.7294 41.3833 15.7294 28.262 17.1337C22.8995 17.7562 17.762 22.8994 17.1338 28.2619C15.7295 41.3831 15.7295 54.6168 17.1338 67.7381C17.7563 73.1006 22.8995 78.2437 28.262 78.8662Z",
    fill: "url(#paint0_linear_2698_104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0004 43.2C29.9622 42.3418 31.2248 41.8994 32.5119 41.9697C33.799 42.04 35.0059 42.6172 35.8685 43.575L43.2092 51.75L60.2135 33.7162C61.1036 32.7997 62.3186 32.2702 63.5958 32.2421C64.8731 32.214 66.1102 32.6897 67.0396 33.5662C67.9691 34.4427 68.5164 35.6498 68.5632 36.9265C68.61 38.2032 68.1526 39.4471 67.2898 40.3894L46.6648 62.2687C46.2106 62.7524 45.6622 63.138 45.0534 63.4018C44.4446 63.6655 43.7883 63.8019 43.1248 63.8025H43.0648C42.3914 63.7945 41.7271 63.6467 41.1138 63.3685C40.5005 63.0903 39.9518 62.6877 39.5023 62.1862L28.6273 50.0681C27.766 49.1079 27.3215 47.8448 27.3914 46.5568C27.4614 45.2688 28.0402 44.0613 29.0004 43.2Z",
    fill: "url(#paint1_linear_2698_104)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2698_104",
    x1: 75.0788,
    y1: 75.0787,
    x2: 20.9213,
    y2: 20.9212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13B601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#13B601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBF4B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2698_104",
    x1: 57.1854,
    y1: 51.75,
    x2: 38.8142,
    y2: 33.3787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBF4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2698_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.c0446adef4ea2b54cde132b5158e5bfd.svg";
export { ForwardRef as ReactComponent };